// Display mapping for the onboarding lifecycle stages (ITDEVELOP-3227): the requests
// table and, later, the review step render a stage as a label + TagComponent variant.
import type { TagVariant } from '@/components/tables/types';
import { onboardingStageEnum, type OnboardingStage } from '@/gen/types/OnboardingStage';

export interface OnboardingStageDisplay {
    label: string;
    variant: TagVariant;
}

const STAGE_DISPLAY: Record<OnboardingStage, OnboardingStageDisplay> = {
    [onboardingStageEnum.Draft]: { label: 'Draft', variant: 'default' },
    [onboardingStageEnum.Submitted]: { label: 'Pending approval', variant: 'warning' },
    [onboardingStageEnum.Approved]: { label: 'Approved', variant: 'success' },
    [onboardingStageEnum.Declined]: { label: 'Declined', variant: 'danger' },
    [onboardingStageEnum.Acknowledged]: { label: 'Acknowledged', variant: 'info' },
    [onboardingStageEnum.OrganizationCreated]: { label: 'Organization created', variant: 'done' },
};

export function onboardingStageDisplay(stage: OnboardingStage): OnboardingStageDisplay {
    return STAGE_DISPLAY[stage] ?? { label: stage, variant: 'default' };
}
